import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../services/authService';
import { useI18n } from '../i18n/I18nProvider';
import Spinner from '../components/Spinner';

const LoginPage = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useI18n();
  const { email, password } = formData;

  const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      setLoading(true);
      await authService.login(email, password);
      navigate('/');
    } catch (err) {
      if (err.response && err.response.data && err.response.data.msg) {
        setError(err.response.data.msg);
      } else {
        setError(t('auth.unexpectedError'));
      }
      console.error('Login failed', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <img src="/logo-smartbin.svg" alt="SmartBin" className="auth-logo" loading="lazy" />
        <h2 className="auth-title">{t('appTitle')}</h2>
        <form onSubmit={handleLogin} noValidate>
          <div className="auth-form-group">
            <input
              className="auth-input"
              type="email"
              placeholder={t('auth.email')}
              name="email"
              value={email}
              onChange={onChange}
              required
              autoComplete="username"
              disabled={loading}
            />
          </div>
          <div className="auth-form-group auth-password-wrapper">
            <input
              className="auth-input"
              type={showPassword ? 'text' : 'password'}
              placeholder={t('auth.password')}
              name="password"
              value={password}
              onChange={onChange}
              required
              autoComplete="current-password"
              disabled={loading}
              aria-describedby="password-visibility-toggle"
            />
            <button
              type="button"
              id="password-visibility-toggle"
              className="auth-password-toggle"
              onClick={() => setShowPassword(p => !p)}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
              aria-pressed={showPassword}
              disabled={loading}
            >
              {showPassword ? (
                /* Eye off icon */
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a21.77 21.77 0 0 1 5.06-6.94M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 8 11 8a21.83 21.83 0 0 1-2.63 3.95" />
                  <path d="M14.12 14.12A3 3 0 0 1 9.88 9.88" />
                  <line x1="1" y1="1" x2="23" y2="23" />
                </svg>
              ) : (
                /* Eye icon */
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              )}
            </button>
          </div>
          {error && <div className="auth-error" role="alert">{error}</div>}
          <button className="btn auth-submit" type="submit" disabled={loading}>
            {loading && <Spinner size={22} stroke={4} light />}
            {!loading && t('auth.login')}
            {loading && <span style={{ marginLeft: 8 }}>{t('auth.login')}</span>}
          </button>
        </form>
        <div className="auth-footer-note">SmartBin © {new Date().getFullYear()}</div>
      </div>
    </div>
  );
};

export default LoginPage;